"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "volterra": {
    "6051e27a": [{
      "hkey": "7a3ab3c1",
      "slug": "volterra",
      "name": "Volterra",
      "primary": true,
      "skipSearch": false
    }],
    "montemiccioli": [{
      "hkey": "7a3ab3c1",
      "slug": "volterra",
      "name": "Volterra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4e64bc61": [{
      "hkey": "7a3ab3c1",
      "slug": "volterra",
      "name": "Volterra",
      "primary": true,
      "skipSearch": false
    }],
    "ponsano": [{
      "hkey": "7a3ab3c1",
      "slug": "volterra",
      "name": "Volterra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6e124f8c": [{
      "hkey": "7a3ab3c1",
      "slug": "volterra",
      "name": "Volterra",
      "primary": true,
      "skipSearch": false
    }],
    "sensano": [{
      "hkey": "7a3ab3c1",
      "slug": "volterra",
      "name": "Volterra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "275788b7": [{
      "hkey": "7a3ab3c1",
      "slug": "volterra",
      "name": "Volterra",
      "primary": true,
      "skipSearch": false
    }],
    "ulignano": [{
      "hkey": "7a3ab3c1",
      "slug": "volterra",
      "name": "Volterra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "235ada20": [{
      "hkey": "7a3ab3c1",
      "slug": "volterra",
      "name": "Volterra",
      "primary": true,
      "skipSearch": false
    }],
    "vicarello": [{
      "hkey": "7a3ab3c1",
      "slug": "volterra",
      "name": "Volterra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;